import { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import NavTabs from '../../../NavTabs';

// The sentinel lets the sticky row gain navigation-chrome styling only once
// it reaches the mobile header offset. Route/active state remains in NavTabs.
const CompanyDetailMobileTabs = ({ items }) => {
    const sentinelRef = useRef(null);
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const sentinel = sentinelRef.current;
        if (!sentinel) return undefined;

        const observer = new IntersectionObserver(
            ([entry]) => setIsSticky(!entry.isIntersecting),
            { rootMargin: '-112px 0px 0px 0px', threshold: 0 }
        );

        observer.observe(sentinel);
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <span ref={sentinelRef} className="company-detail-mobile-tabs-sentinel" aria-hidden="true" />
            <Row className={`mb-4 mt-3 company-detail-mobile-tabs-row${isSticky ? ' is-sticky' : ''}`}>
                <Col>
                    <NavTabs items={items} trackOverflow />
                </Col>
            </Row>
        </>
    );
};

export default CompanyDetailMobileTabs;
